import React from 'react';

const Footer = () => {
  return (
    <footer className="footer">
      <p className="footer-text">
        ConnectIn 2026 &copy; All rights reserved
      </p>
    </footer>
  );
};

export default Footer;
